import { TokenIcon } from "@tutellus/tutellus-components"
import styles from "./index.module.css"
import { useFormatAmounts } from "../../../hooks/useFormatAmounts"

export type TokenAmountCellProps = {
  tokenID: string
  amount: number
}

export const TokenAmountCell = ({ tokenID, amount }: TokenAmountCellProps) => {
  const { formatAmount } = useFormatAmounts()
  const formattedAmount = formatAmount(amount)

  return (
    <div className={styles.tokenAmountCell}>
      <p className={styles.tokenAmountCellText}>{formattedAmount}</p>
      <TokenIcon iconKey={tokenID} size="m" />
    </div>
  )
}
